import React from 'react';
import cn from 'classnames';
import styles from './Loader.module.scss';

export function Loader() {
  return (
    <div className={styles.loaderSpinner}>
      <div className={styles.loaderBounce} />
      <div className={cn([styles.loaderBounce, styles.second])} />
    </div>
  );
}
